<template>
  <div class="new-request__body">
    <app-loading
      :loading="isLoading"
      :text="'Carregando pedido...'"
    ></app-loading>
    <div v-if="errorOnLoad">
      Não foi possível carregar o pedido
    </div>
    <div v-if="!isLoading">
      <div
        class="new-row"
        style="display: flex; justify-content: space-between;"
      >
        <div class="request-order__tab" :class="'ativo'">
          <icon name="product-box" :color="'#4d76c8'" />
          <span style="margin-left: 5px;">Produtos</span>
          <div class="dot"></div>
          <span
            :class="{
              has: zepplinRequest.requestCompanyBrandProducts.length > 0,
            }"
            >{{ zepplinRequest.requestCompanyBrandProducts.length }}</span
          >
        </div>
        <div style="cursor: pointer;" @click="generateReceipt()">
          <icon name="printer" width="20" height="20" />
        </div>
      </div>
      <div>
        <div
          :class="'disabled'"
          v-if="zepplinRequest && zepplinRequest.requestCompanyBrandProducts"
        >
          <div class="request-section products__container">
            <table class="request-table" style="margin: 0 0">
              <thead>
                <tr
                  class="tabela"
                  style="justify-content: space-between; display: flex;"
                >
                  <th
                    style="display: flex; justify-content: flex-start; width: 300px;"
                  >
                    <span>Produto</span>
                  </th>
                  <th
                    style="display: flex; justify-content: center; width: 70px;"
                  >
                    <span>Quantia</span>
                  </th>
                  <th
                    style="display: flex; justify-content: center; width: 70px;"
                  >
                    <span>Valor</span>
                  </th>
                  <th
                    style="display: flex; justify-content: center; width: 70px;"
                  >
                    <span>Des./Acr.</span>
                  </th>
                  <th
                    style="display: flex; justify-content: flex-end; width: 70px;"
                  >
                    <span>Subtotal</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <div
                  style="border-bottom: solid 1px #161A1D; padding-bottom: 5px;"
                  v-for="requestCompanyBrandProduct of zepplinRequest.requestCompanyBrandProducts"
                  :key="requestCompanyBrandProduct.id"
                >
                  <tr style="display: flex; justify-content: space-between;">
                    <td
                      class="input"
                      style="width: 300px; display: flex; jusitfy-content: flex-start;"
                    >
                      {{
                        requestCompanyBrandProduct.companyBrandProduct
                          .brandProduct.product.name
                      }}
                      <div
                        v-if="
                          requestCompanyBrandProduct.companyBrandProduct
                            .brandProduct.brand
                        "
                        class="dot"
                      ></div>
                      {{
                        requestCompanyBrandProduct.companyBrandProduct
                          .brandProduct.brand &&
                          requestCompanyBrandProduct.companyBrandProduct
                            .brandProduct.brand.name
                      }}
                      <div
                        v-if="
                          requestCompanyBrandProduct.companyBrandProduct
                            .brandProduct.name
                        "
                        class="dot"
                      ></div>
                      {{
                        requestCompanyBrandProduct.companyBrandProduct
                          .brandProduct &&
                          requestCompanyBrandProduct.companyBrandProduct
                            .brandProduct.name
                      }}
                    </td>
                    <td
                      style="width: 70px; display: flex; justify-content: center;"
                      class="input"
                    >
                      {{ requestCompanyBrandProduct.quantity }}
                    </td>
                    <td
                      style="width: 70px; display: flex; justify-content: center;"
                      class="input"
                    >
                      {{
                        utils.formatMoney(
                          requestCompanyBrandProduct.unitPrice,
                          2,
                          "",
                          ".",
                          ","
                        )
                      }}
                    </td>
                    <td
                      style="width: 70px; display: flex; justify-content: center;"
                      class="input"
                    >
                      {{
                        utils.formatMoney(
                          requestCompanyBrandProduct.unitDiscount,
                          2,
                          "",
                          ".",
                          ","
                        )
                      }}
                    </td>
                    <td
                      style="width: 70px; display: flex; justify-content: flex-end;"
                      class="input"
                    >
                      {{
                        utils.formatMoney(
                          utils.getMoneyAsDecimal(
                            requestCompanyBrandProduct.unitPrice -
                              requestCompanyBrandProduct.unitDiscount +
                              sumRequestExtras(
                                requestCompanyBrandProduct.requestCompanyBrandProductExtras
                              ) *
                                requestCompanyBrandProduct.quantity
                          ),
                          2,
                          "",
                          ".",
                          ","
                        )
                      }}
                    </td>
                  </tr>
                  <div>
                    <tr v-if="requestCompanyBrandProduct.obs">
                      <span>Observação:</span>
                      {{
                        requestCompanyBrandProduct.obs
                      }}
                    </tr>
                    <tr
                      v-for="requestCompanyBrandProductExtra of requestCompanyBrandProduct.requestCompanyBrandProductExtras"
                      :key="requestCompanyBrandProductExtra.id"
                    >
                      <div
                        v-for="extraChoice of requestCompanyBrandProductExtra
                          .requestExtra.requestExtraChoices"
                        :key="extraChoice.id"
                      >
                        <span>{{ extraChoice.title }}</span>
                        <span v-if="extraChoice.quantity">
                          x{{ extraChoice.quantity }}</span
                        >
                        <span v-if="extraChoice.unitPrice">
                          {{
                            utils.formatMoney(
                              extraChoice.unitPrice * extraChoice.quantity,
                              2,
                              "R$",
                              ".",
                              ","
                            )
                          }}</span
                        >
                      </div>
                    </tr>
                  </div>
                </div>
              </tbody>
            </table>
            <div
              class="new-pedido-button"
              :class="{ 'total-products__zepplin': request.zepplinId }"
              style="display: flex; justify-content: space-between; align-items: flex-end"
            >
              <div v-if="zepplinRequest.coupon">
                <span
                  style="display: flex; align-items: center; justify-content: space-between; font-family: Arial, Helvetica, sans-serif;font-size: 14px;color: #73777B; margin-right: 50px"
                >
                  <icon
                    style="margin-right: 3px;"
                    name="discount"
                    width="20"
                    height="20"
                    color="#4D76C8"
                  />
                  {{ zepplinRequest.coupon.name }} /
                  <span style="font-size: 14px; margin-left: 5px;">
                    R$
                    <span>{{
                      this.utils.formatMoney(
                        zepplinRequest.coupon.amount,
                        2,
                        "",
                        ".",
                        ","
                      )
                    }}</span>
                  </span>
                </span>
              </div>

              <div
                style="display: flex; justify-content: space-between; align-items: center;"
              >
                <div>
                  <span
                    style="font-family: Arial, Helvetica, sans-serif;font-size: 14px;color: #73777B; margin-right: 50px"
                  >
                    Subtotal /
                    <span style="font-size: 14px;">
                      R$
                      <span>{{
                        this.utils.formatMoney(
                          getTotalRequestCompanyBrandProducts(),
                          2,
                          "",
                          ".",
                          ","
                        )
                      }}</span>
                    </span>
                  </span>
                </div>
                <div>
                  <span
                    style="font-family: Arial, Helvetica, sans-serif;font-size: 14px;color: #73777B; margin-right: 50px"
                  >
                    Total /
                    <span style="font-size: 14px;">
                      R$
                      <span>{{
                        this.utils.formatMoney(getRequestTotal, 2, "", ".", ",")
                      }}</span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="request-section" :class="'disabled'">
          <table class="tabela-02" style="margin: 0">
            <thead>
              <tr
                class="tabela"
                style="justify-content: space-between; display: flex;"
              >
                <th
                  style="display: flex; justify-content: flex-start; width: 350px;"
                >
                  <span>Forma de pagamento</span>
                </th>
                <th
                  style="display: flex; justify-content: center; width: 120px;"
                >
                  <span>Taxa de entrega</span>
                </th>
                <th
                  style="display: flex; justify-content: flex-end; width: 120px;"
                >
                  <span>A receber</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style="display: flex; justify-content: space-between;">
                <td class="input" style="width: 350px;">
                  {{ zepplinRequest.requestPayment.paymentMethod.name }}
                </td>
                <td
                  class="input"
                  style="width: 120px; display: flex; justify-content: center;"
                >
                  {{
                    utils.formatMoney(
                      zepplinRequest.deliveryTax,
                      2,
                      "",
                      ".",
                      ","
                    )
                  }}
                </td>
                <td
                  class="input"
                  style="width: 120px; display: flex; justify-content: flex-end;"
                >
                  {{
                    utils.formatMoney(
                      zepplinRequest.totalPrice,
                      2,
                      "",
                      ".",
                      ","
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="new-pedido-card" :class="'disabled'">
          <div
            class="request-section"
            style="flex-grow: 1; width: 50%; height: 80px;"
          >
            <div
              style="display: flex; justify-content: space-between; align-items: center;"
            >
              <span
                style="font-family: Arial, Helvetica, sans-serif;font-size: 14px;margin: 0px 5px;color: #73777B;"
                >Observações
              </span>
              <div
                style="width: 100%; font-family: Arial, Helvetica, sans-serif; font-size: 13px; color: #E7E8E8; margin: 0px 15px 0px 0px;"
              >
                {{ zepplinRequest.obs }}
              </div>
            </div>
          </div>

          <div
            class="request-section"
            :class="{
              'zepplin-request-deliveryDate':
                request.zepplinId &&
                !request.isScheduled &&
                request.STATE_request.persistedStatus === 'pending',
            }"
            style="margin-left:10px; width: 50%; display: flex; flex-direction: column; justify-content: space-between; align-items: center; height: 80px;"
          >
            <div>
              <span
                style="font-style: italic; width: 100%; flex-basis: 130px; font-family: Arial, Helvetica, sans-serif;font-size: 13px; margin: 0px 5px;color: #73777B;"
              >
                pedido feito às
                {{
                  moment(zepplinRequest.dateCreated)
                    .local(true)
                    .format("DD/MM/YYYY HH:mm")
                }}
              </span>
            </div>
            <div
              style="flex-grow: 1;margin-left:10px; height:50px; width: 100%; display: flex; justify-content: space-between; align-items: center;"
            >
              <span
                style="width: 100%; flex-basis: 130px; font-family: Arial, Helvetica, sans-serif;font-size: 14px;margin: 0px 5px;color: #73777B;"
                >Entrega
                {{
                  request.deliveryDate && !request.isScheduled ? "até" : ""
                }}</span
              >
              <div
                :class="{
                  enabled:
                    !zepplinRequest.isScheduled &&
                    request.STATE_request.persistedStatus === 'pending',
                }"
                style="width: 100%; display: flex; align-items: center;"
              >
                <app-datetime-selector
                  class="input-select"
                  :value="
                    zepplinRequest.deliveryDate
                      ? moment(zepplinRequest.deliveryDate)
                          .local()
                          .format()
                      : null
                  "
                  @input="onDeliveryDateChange($event)"
                  :config="deliveryDateSelectorConfig"
                  :placeholder="'selecione para prosseguir'"
                >
                </app-datetime-selector>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Portuguese } from "flatpickr/dist/l10n/pt";
import moment from "moment";
import * as FileSaver from "file-saver";

import RequestHistoryComponent from "./RequestHistory";
import RequestChatComponent from "./RequestChat";
import LoadingComponent from "../../../../../components/Utilities/Loading";

import ReceiptZepplinHelper from "../../../../../helpers/ReceiptZepplinHelper";
import { mapState } from "vuex";

import ZepplinRequestsAPI from "../../../../../api/zepplin/requests";

export default {
  props: ["request"],
  mixins: [ReceiptZepplinHelper],
  components: {
    "app-request-history": RequestHistoryComponent,
    "app-request-chat": RequestChatComponent,
    "app-loading": LoadingComponent,
  },
  data() {
    return {
      datetimeSelectorConfig: {
        altInput: true,
        altFormat: "d/m/Y",
        dateFormat: "Z",
        locale: Portuguese,
        time_24hr: true,
        enableTime: true,
      },
      deliveryDateSelectorConfig: {
        altInput: true,
        altFormat: "d/m/Y H:i",
        dateFormat: "Z",
        defaultHour: this.request.zepplinId
          ? moment()
              .add(
                this.VXORM.CompanySetting.query()
                  .where("key", "estimatedDeliveryTime")
                  .first()
                  ? this.VXORM.CompanySetting.query()
                      .where("key", "estimatedDeliveryTime")
                      .first().value
                  : 20,
                "minutes"
              )
              .hour()
          : "12",
        defaultMinute: this.request.zepplinId
          ? moment()
              .add(
                this.VXORM.CompanySetting.query()
                  .where("key", "estimatedDeliveryTime")
                  .first()
                  ? this.VXORM.CompanySetting.query()
                      .where("key", "estimatedDeliveryTime")
                      .first().value
                  : 20,
                "minutes"
              )
              .minute()
          : "00",
        locale: Portuguese,
        time_24hr: true,
        enableTime: true,
        noCalendar: true,
        minTime:
          moment(this.request.dateCreated)
            .local()
            .format("DD/MM") ===
          moment()
            .local()
            .format("DD/MM")
            ? moment(this.request.dateCreated)
                .local()
                .format("HH:mm")
            : null,
      },
      zepplinRequest: null,
      errorOnLoad: false,
      isLoading: true,
    };
  },
  computed: {
    ...mapState("auth", ["company"]),

    getRequestTotal() {
      const couponDiscount =
        this.zepplinRequest && this.zepplinRequest.coupon
          ? +this.zepplinRequest.coupon.amount
          : 0;
      return this.getTotalRequestCompanyBrandProducts() - couponDiscount;
    },
  },
  methods: {
    sumRequestExtras(requestCompanyBrandProductExtras) {
      return _.sumBy(
        requestCompanyBrandProductExtras,
        (requestCompanyBrandProductExtra) => {
          if (!requestCompanyBrandProductExtra.requestExtra) return 0;
          return _.sumBy(
            requestCompanyBrandProductExtra.requestExtra.requestExtraChoices,
            (requestExtraChoice) => {
              if (!requestExtraChoice.unitPrice) return 0;
              return (
                parseFloat(requestExtraChoice.unitPrice) *
                requestExtraChoice.quantity
              );
            }
          );
        }
      );
    },

    getTotalRequestCompanyBrandProducts() {
      return _.sumBy(
        this.zepplinRequest.requestCompanyBrandProducts,
        (requestCompanyBrandProduct) => {
          return (
            (requestCompanyBrandProduct.unitPrice -
              requestCompanyBrandProduct.unitDiscount +
              this.sumRequestExtras(
                requestCompanyBrandProduct.requestCompanyBrandProductExtras
              )) *
            requestCompanyBrandProduct.quantity
          );
        }
      );
    },

    onDeliveryDateChange(value) {
        this.request.$update({
            where: this.request.id,
            data: { deliveryDate: value ? moment(value).local().format() : null }
        })
        this.zepplinRequest.deliveryDate = moment(value).local().format()
    },  

    generateReceipt() {
        const text = this.formatValues(this.zepplinRequest)
        var file = new File([text], `${this.request.code}.txt`, {type: "text/plain;charset=utf-8"})
        FileSaver.saveAs(file)
    }
  },
  async mounted() {
    this.isLoading = true;
    try {
      const zepplinRequest = await ZepplinRequestsAPI.get(
        this.request.zepplinId
      );
      this.zepplinRequest = zepplinRequest.data.request;
    } catch (err) {
      console.error(err);
      this.errorOnLoad = true;
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style lang="scss">
span {
  font-family: Arial, Helvetica, sans-serif;
}
.new-produtos {
  display: flex;
  flex-direction: row;
}
.new-historico {
  background: #23272b;
  border-radius: 2px;
  margin: 0px -10px 36px -10px;
}
.new-direita {
  display: flex;
  flex-direction: column;
  padding: 5px 0px 0px 0px;
}
.tabela-span {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  color: #73777b;
}
.ativo {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  color: #c3c5c6;
  .span5 {
    margin-left: -30px;
  }
  .span2 {
    margin-left: 15px;
  }
}
.request-section.products__container {
  background-color: #31363c;
}
.request-section.services__container {
  background-color: #31363c;
}
.request-section {
  height: auto;
  background: #23272b;
  margin: 0 0 10px 0;
  padding: 10px;
  border-radius: 2px;
  input[type="button"] {
    border: 0px;
    background: #4d76c8;
    border-radius: 2px;
    color: white;
    margin-top: 15px;
    height: 24px;
    cursor: pointer;
  }
  .th2 {
    img {
      margin-left: -5px;
      margin-right: 18px;
      padding-top: 5px;
    }
  }
  .th10 {
    img {
      margin-left: 10px;
      padding-top: 7px;
    }
  }
  .th6 {
    img {
      margin-left: -60px;
      margin-right: 18px;
      padding-top: 5px;
    }
  }
}
.new-pedido-card {
  display: flex;
  flex-direction: row;
  text-align: center;
}
.new-request__body {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 20px 10px 0px 10px;
  background: #161a1d;
  .new-style-span {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    padding: 0px;
    margin: 0px;
  }
}
.new-pedido-span {
  display: flex;
  flex-direction: row;
  float: right;
  margin: 20px 30px 0px 0px;
}
.new-pedido-input {
  margin: 15px 0px;
  height: 24px;
  width: 100px;
  background: #4d76c8;
  border: 0px;
  border-radius: 2px;
  color: #e7e8e8;
  font-size: 12px;
  cursor: pointer;
}
.new-row {
  display: flex;
  flex-direction: row;
  align-content: center;
}
.new-column {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.comodato {
  padding: 7px 10px 5px 12px;
  background: #31363c;
  border-radius: 2px;
  font-family: Arial, Helvetica, sans-serif;

  font-size: 14px;
  height: 32px;
  cursor: pointer;
}
.produtos.ativo,
.historico.ativo,
.comodato.ativo {
  background: #23272b;
}
.new-pedido-button {
  span {
    font-size: 18px;
    color: #c3c5c6;
  }
}

.input-obs {
  background: transparent;
  border: 0;
  border-bottom: 1px solid rgb(115, 119, 123);
}

.prefix-subtotal {
  font-size: 0.6em;
}

.no-padding {
  padding: 0;
}

.input-select {
  padding: 0;
  margin: 0;
  width: 100%;
}
.input-select::placeholder {
  text-transform: uppercase;
  font-size: 0.8em;
}

.request-order__tab {
  display: flex;
  flex-direction: row;
  margin-right: 1px;

  padding: 7px 10px 5px 12px;
  background: #23272b;
  font-size: 14px;
  height: 32px;
  display: flex;
  cursor: pointer;
  span.has {
    color: #c3c5c6;
  }
  &.ativo {
    background-color: #31363c;
    span {
      color: #4d76c8;
    }
  }
  &:first-child {
    border-top-left-radius: 5px;
  }
  &:last-child {
    margin-right: 0;
    border-top-right-radius: 5px;
  }
}

.disabled {
  pointer-events: none;
}

.enabled {
  pointer-events: fill;
}

.total-products__zepplin {
  justify-content: flex-end !important;
  margin-top: 10px;
}

.zepplin-request-deliveryDate {
  border: 1px dashed #e0634a;
}

.input {
  margin: 0;
}
</style>
